import { SearchContext } from "./SearchContext"
import { useState } from "react"
import { getGlobalSearchSuggestions } from "../../global-services/search.service"

function SearchProvider({ children }) {
  const [suggestions, setSuggestions] = useState([])

  const fetchSuggestions = async (text) => {
    console.log('Fetching suggestions for:', text);
    try {
      const results = await getGlobalSearchSuggestions(text)
      console.log('Suggestions results:', results);
      setSuggestions(results)
    } catch (error) {
      console.error('fetchSuggestions error:', error);
      setSuggestions([])
    }
  }

  return (
    <SearchContext.Provider
      value={{
        suggestions,
        setSuggestions,
        fetchSuggestions,
      }}
    >
      {children}
    </SearchContext.Provider>
  )
}

export default SearchProvider
